import { render } from "./LayoutES.vue?vue&type=template&id=4ffaa05f&scoped=true"
import script from "./LayoutES.vue?vue&type=script&lang=js"
export * from "./LayoutES.vue?vue&type=script&lang=js"

import "./LayoutES.vue?vue&type=style&index=0&id=4ffaa05f&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ffaa05f"]])

export default __exports__